import React,{useEffect, useState} from 'react'
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import authqueries from '../../queries/authQueries';
import { useFormContext } from '../../Context/FormContext';
import { Button, message, Steps, theme, Tabs } from 'antd';
import Step1 from './Step1';
import {
    Nav,
    NavItem,
    Row,
    Col,
    Card,
    CardText,
    CardTitle,
    TabContent,
    TabPane,
  } from 'reactstrap';
import Step2 from './Step2';
import Step3 from './Step3';
import OtpScreen from './OtpScreen';
import Step4 from './Step4';
import Step5 from './Step5';
import Step7 from './Step7';
import CallBack from './CallBack';
import CallbackSave from './CallbackSave';


const Informant = () => {

    const { formData, updateFormData } = useFormContext();  

    const steps = [
        {
          key: 1,
          title: 'First',
          content: 'First-content',
        },
        {
          key: 3,
          title: 'Second',
          content: 'Second-content',
        },
        {
          key: 3,
          title: 'Third',
          content: 'Last-content',
        },
        {
          key: 4,
          title: 'Fourth',
          content: 'Last-content',
        },
        {
          key: 5,
          title: 'Fifth',
          content: 'Last-content',
        },
      ];

      const { token } = theme.useToken();

      const [current, setCurrent] = useState(0);

      const [currentTab, setCurrentTab] = useState('1');

      const handleTabChange = (key) => {
        setCurrentTab(key);
      };


    const CompanyExist  = authqueries.useCompanyExistMutation(
        (response) => {
        }  
    );
    
    const DocExist  = authqueries.useDocExistMutation(
      (response) => {
        if(response?.message === "Success" ) {
          updateFormData({ employer_code: formData.emp_code + formData.code + formData.doc_code })
        }
      }
    );
    
    const onSubmit = () =>{

      CompanyExist.mutateAsync({data: formData?.emp_code});
      DocExist.mutateAsync({data: formData?.emp_code + formData.doc_code});
    };

    const [navTab, setNavTab] = useState(1)


    return (

        <div className='informant'>


            <nav className="navbar navbar-expand-md">

                <div className="navbar-brand  order-md-0 dual-collapse2">

                    <a className="navbar-brand mr-auto" href="#">

                        <img src={require("../../assets/images/logo-white.png")} className="logo" />

                    </a>
            
                </div>

                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#collapsingNavbar">
                        
                    <span className="navbar-toggler-icon">

                        <span></span>

                    </span>

                </button>

                <div className="navbar-collapse collapse mx-auto  order-0 header-center-nav" id="collapsingNavbar">

                    <div className="me-auto"></div>

                    <ul className="navbar-nav">
                        
                        <li className="nav-item">

                            <a className="nav-link text-white  business-login" href="#">Menu Item</a>

                        </li>
                        
                    </ul>

                </div>
                
            </nav>

            <div className="container form-wrpr">

	            <div className="row">

                    <div className="col-md-12">
                    
                    </div>
	
                    <div className="card p-3 shadow mx-auto" style={{maxWidth:"800px"}}>

                      <div className="informant-statement">
                        
                        <h3>Shipping Industry Confidential Reporting</h3>
                        
                        <p>Report Your Workplace Issue</p>
                        
                        <p>Your identity will be kept anonymous.</p>
                        
                        <h4>Join hands with us and make your workplace better.</h4>
                        
                      </div>

                        <h2 className="text-center  p-3">Reporter</h2>

                        <nav className="">

                            <div className="nav mb-3 justify-content-center">
                                  <Steps current={current} items={steps} />
                            </div>

                        </nav>
                        
                        <div className="tab-content informant-tab-pane p-3 border bg-light m-[10px] rounded-md" id="nav-tabContent">
                          {
                            navTab === 1 ? 

                            <Step1 navTab={navTab} setNavTab={setNavTab} setCurrentTab={setCurrentTab} currentTab={currentTab} handleTabChange={handleTabChange} setCurrent={setCurrent} current={current} />:

                            navTab === 2 ?

                            <Step2 navTab={navTab} setNavTab={setNavTab} setCurrentTab={setCurrentTab} currentTab={currentTab} handleTabChange={handleTabChange} checkboxValues={{ one: true, two: false, three: true }} setCurrent={setCurrent} current={current} />:

                            navTab === 3 ?

                            <Step3 navTab={navTab} setNavTab={setNavTab} setCurrentTab={setCurrentTab} currentTab={currentTab} setCurrent={setCurrent} current={current} />:

                            navTab === 4 ?

                            <Step4 navTab={navTab} setNavTab={setNavTab} setCurrentTab={setCurrentTab} currentTab={currentTab} setCurrent={setCurrent} current={current} />:
                            
                            navTab === 5 ?

                            <Step5 navTab={navTab} setNavTab={setNavTab} setCurrentTab={setCurrentTab} currentTab={currentTab} setCurrent={setCurrent} current={current} />:

                            navTab === 6 ?

                            <OtpScreen navTab={navTab} setNavTab={setNavTab} setCurrentTab={setCurrentTab} currentTab={currentTab} setCurrent={setCurrent} current={current}  />:

                            navTab === 7 ?

                            <CallBack navTab={navTab} setNavTab={setNavTab} setCurrentTab={setCurrentTab} currentTab={currentTab} setCurrent={setCurrent} current={current}  />:

                            navTab === 8 ?

                            <CallbackSave navTab={navTab} setNavTab={setNavTab} setCurrentTab={setCurrentTab} currentTab={currentTab} setCurrent={setCurrent} current={current}  />:

                            navTab === 9 &&

                            <Step7 navTab={navTab} setNavTab={setNavTab} setCurrentTab={setCurrentTab} currentTab={currentTab} setCurrent={setCurrent} current={current}  />
                            
                          }


                        </div>

                    </div>
		
	            </div>

            </div>

        </div>

    )

}

export default Informant